import { FC, ReactNode } from "react";

interface MarginaliaGroupProps {
	children: ReactNode;
}

const MarginaliaGroup: FC<MarginaliaGroupProps> = ({ children }) => (
	<div className="flex flex-col gap-3">
		{children}
	</div>
);

export { MarginaliaGroup };
